module.exports = __webpack_public_path__ + "img/view-compliance.fde92c53.svg";